import { Fragment, FunctionalComponent, h, VNode } from 'preact';
import {
  FeedbackFormContainer,
  FeedbackFormHeading,
  FeedbackFormLogo,
  FeedbackFormSubheading,
} from './feedback-form.styles';
import { useScreen } from '@hooks/useScreen';
import Icon from '@components/atoms/icon/icon';
import { closeWidget } from '@components/organisms/widget/widget';
import { resetFormStep } from './feedback-form';
import { resetCaptchaToken, resetRatingSelection } from './ratings';
import SkeletonLoader from '@components/molecules/skeleton/skeleton';

const FeedbackFormComplete: FunctionalComponent<{ isLoading: boolean; success: boolean }> = ({
  isLoading,
  success,
}): VNode => {
  const { isMobile } = useScreen();

  return (
    <FeedbackFormContainer
      $noGap
      className="feedback-form"
      $isMobile={isMobile}
      onMouseOut={() => {
        if (!isLoading) {
          setTimeout(() => {
            closeWidget();
            resetRatingSelection();
            resetFormStep();
            resetCaptchaToken();
          }, 2000);
        }
      }}
    >
      <FeedbackFormLogo className="feedback-form-logo">
        <Icon name="tick" brandFill />
      </FeedbackFormLogo>
      {isLoading && <SkeletonLoader />}
      {!isLoading && (
        <Fragment>
          <FeedbackFormHeading
            className="feedback-form-complete-heading"
            style={{
              width: 'auto',
              margin: '10px 20px 0 20px',
              padding: '0',
            }}
          >
            {success ? 'Feedback Submitted!' : 'Something is wrong!'}
          </FeedbackFormHeading>
          <FeedbackFormSubheading
            className="feedback-form-complete-body"
            style={{
              fontSize: '16px',
              padding: '0',
              margin: 0,
            }}
          >
            {success
              ? 'Thank you for your feedback, our team will review it soon.'
              : 'Your feedback has not reached us, our team are working on it!'}
          </FeedbackFormSubheading>
        </Fragment>
      )}
    </FeedbackFormContainer>
  );
};

export default FeedbackFormComplete;
